import { chakra } from '@chakra-ui/react';

import { ModalWrapper } from '../../../../components/modal-wrapper';

export const SessionTimeoutModalWrapper = chakra(ModalWrapper, { baseStyle: { flexDirection: 'column' } });
